<mat-card>
  <mat-card-content class="card-spinner" *ngIf="loader">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </mat-card-content>
  <mat-card-title>Transacciones</mat-card-title>
  <form [formGroup]="searchForm" style="margin-top: 2rem" fxLayout="row" fxLayoutGap="2%">
    <mat-form-field appearance="outline" fxFlex="28%">
      <mat-label>ID usuario o Correo</mat-label>
      <input matInput type="number" class="input-number" placeholder="ID usuario o Correo" formControlName="idusuario" (keydown.enter)="getTransactions()">
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="28%">
      <mat-label>ID tx</mat-label>
      <input matInput type="number" class="input-number" placeholder="ID tx" formControlName="id" (keydown.enter)="getTransactions()">
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="28%">
      <mat-label>Terminación</mat-label>
      <input matInput type="number" class="input-number" placeholder="Terminación" formControlName="terminacion" (keydown.enter)="getTransactions()">
    </mat-form-field>
    <mat-checkbox class="example-margin" fxFlex="16%" fxFlexAlign="center" formControlName="sinfirma" (change)="getTransactions()">Sin firma</mat-checkbox>
  </form>
  <mat-card-content>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table-default">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let element" (click)="detail(element.idtransaccion)"> {{element.idtransaccion}} </td>
      </ng-container>
      <ng-container matColumnDef="monto">
        <th mat-header-cell *matHeaderCellDef> Monto </th>
        <td mat-cell *matCellDef="let element" (click)="detail(element.idtransaccion)"> {{element.monto}} </td>
      </ng-container>
      <ng-container matColumnDef="usuario">
        <th mat-header-cell *matHeaderCellDef> Usuario </th>
        <td mat-cell *matCellDef="let element" (click)="detail(element.idtransaccion)"> {{element.correo}} </td>
      </ng-container>
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef> Estado </th>
        <td mat-cell *matCellDef="let element" (click)="detail(element.idtransaccion)"> {{element.estatus}} </td>
      </ng-container>
      <ng-container matColumnDef="clave">
        <th mat-header-cell *matHeaderCellDef> Clave </th>
        <td mat-cell *matCellDef="let element" (click)="detail(element.idtransaccion)">{{element.clave ? element.clave : '--'}}</td>
      </ng-container>
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef> Fecha </th>
        <td mat-cell *matCellDef="let element" (click)="detail(element.idtransaccion)"> {{element.fechahora | date:'dd-MM-yyyy'}} </td>
      </ng-container>
      <ng-container matColumnDef="msi">
        <th mat-header-cell *matHeaderCellDef> MSI </th>
        <td mat-cell *matCellDef="let element" (click)="detail(element.idtransaccion)"> {{element.cvalue ? element.cvalue : '--'}} </td>
      </ng-container>
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef> Tipo </th>
        <td mat-cell *matCellDef="let element" (click)="detail(element.idtransaccion)"> {{element.tipotransaccion}} </td>
      </ng-container>
      <ng-container matColumnDef="firma">
        <th mat-header-cell *matHeaderCellDef> Firma </th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.firma === '1'" mat-icon-button color="accent" aria-label="firma">
            <mat-icon>image</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; let element; columns: displayedColumns;"></tr>
    </table>

  </mat-card-content>
</mat-card>
